import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { TextInput } from "../../generic/text-input/TextInput";
import { TextLoca } from "../../generic/text/TextLoca";
export var FoundEditDescription = React.memo(function (_a) {
    var coopDescription = _a.coopDescription, setCoopDescription = _a.setCoopDescription, charLimit = _a.charLimit, onSubmit = _a.onSubmit;
    var descrPlaceholder = utilLoca.get(IdLoca.enterCoopDesc_desc);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: IdStyles.TextBoldPrimary + " w100" },
            React.createElement(TextLoca, { id: IdLoca.enterCoopDesc_title })),
        React.createElement(TextInput, { style: IdStyles.CoopFoundDescriptionInput, placeholder: descrPlaceholder, maxLength: charLimit, onChange: setCoopDescription, value: coopDescription, onSubmit: onSubmit })));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/found-edit/FoundEditDescription.tsx
// module id = 2584
// module chunks = 3